<template>
  <v-select class="v-col-auto" density="compact" hide-details variant="outlined">
    <template #append-inner>
      <i-local-arrow2 />
    </template>
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </v-select>
</template>

<style lang="scss">
  .v-overlay-container {
    .v-list-item--density-default.v-list-item--one-line {
      min-height: 42px;
    }
  }
</style>
<style lang="scss" scoped>
  .v-select {
    font-weight: 700;
    :deep(.v-input__control) {
      .v-field__clearable > .v-icon {
        opacity: 1;
      }

      .v-field__append-inner {
        svg {
          margin: auto;
          transition: 0.2s linear;
          opacity: 0.5;
        }
        i {
          display: none;
        }
      }
      &:hover,
      .v-field--focused {
        .v-field__append-inner svg {
          opacity: 1;
        }
      }
    }
  }

  .v-select--active-menu {
    .v-field__append-inner svg {
      transform: scaleY(-1);
    }
  }
</style>
